module.exports = __webpack_public_path__ + "img/serrano.18a73c08.webp";